import _ from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { PrivacyCenterNoticeDto } from "../../../../../common/service/server/dto/PrivacyCenterDto";
import { BiometricIdentifiersPolicyEditor } from "../../../../components/privacyCenter/BiometricIdentifiersPolicyEditor";
import { useUpdateNoticeApi } from "../../../../components/privacyCenter/EditPrivacyCenter";

export function BiometricIdentifiersEditor({
  organizationId,
  privacyCenterId,
  refreshNotice,
  draftNotice,
}: {
  organizationId: string;
  privacyCenterId: string;
  refreshNotice: () => Promise<void>;
  draftNotice: PrivacyCenterNoticeDto;
}) {
  const biometricIdentifiersSection = draftNotice.sections.find(
    (section) => section.anchor === "colorado-biometric-identifiers-policy",
  );

  const [updatedContent, setUpdatedContent] = useState(biometricIdentifiersSection.content);
  const { updateNotice } = useUpdateNoticeApi();

  const debouncedSave = useCallback(
    _.debounce(async (newContent: string) => {
      await updateNotice({
        organizationId,
        privacyCenterId,
        noticeId: draftNotice.publicId,
        updateNoticeBody: {
          sections: [{ id: biometricIdentifiersSection.id, content: newContent }],
        },
      });

      await refreshNotice();
    }, 750),
    [],
  );

  useEffect(() => () => debouncedSave.cancel(), [debouncedSave]);

  return (
    <BiometricIdentifiersPolicyEditor
      audience="consumer"
      header={biometricIdentifiersSection.header}
      content={updatedContent}
      placeholder={
        biometricIdentifiersSection.placeholder ||
        "Enter your biometric identifiers policy content here..."
      }
      onContentChange={(newContent) => {
        setUpdatedContent(newContent);
        debouncedSave(newContent);
      }}
    />
  );
}
